import { motion } from 'framer-motion';
import {
  Box,
  Container,
  Typography,
  Grid,
  Paper,
} from '@mui/material';
import { FeaturesSectionProps } from './types';

const clayCard = {
  bgcolor: 'rgba(255,255,255,0.2)',
  border: '1px solid rgba(255,255,255,0.28)',
  borderRadius: '20px',
  boxShadow: [
    '0 16px 40px rgba(0,0,0,0.4)',
    '0 6px 12px rgba(0,0,0,0.25)',
    'inset 0 2px 0 rgba(255,255,255,0.2)',
    'inset 0 -2px 0 rgba(0,0,0,0.18)',
  ].join(', '),
  transition: 'transform 0.25s ease, box-shadow 0.25s ease',
  '&:hover': {
    transform: 'translateY(-6px) scale(1.01)',
    boxShadow: [
      '0 24px 52px rgba(0,0,0,0.48)',
      '0 8px 16px rgba(0,0,0,0.3)',
      'inset 0 2px 0 rgba(255,255,255,0.22)',
      'inset 0 -2px 0 rgba(0,0,0,0.2)',
    ].join(', '),
  },
};

const clayIconCircle = {
  mb: 2.5,
  width: 60,
  height: 60,
  borderRadius: '50%',
  display: 'grid',
  placeItems: 'center',
  background: (theme: any) =>
    `linear-gradient(145deg, ${theme.palette.primary.light}, ${theme.palette.secondary.main})`,
  boxShadow: [
    '0 10px 24px rgba(99,102,241,0.5)',
    '0 4px 8px rgba(0,0,0,0.22)',
    'inset 0 2px 0 rgba(255,255,255,0.3)',
    'inset 0 -2px 0 rgba(0,0,0,0.18)',
  ].join(', '),
  color: 'common.white',
};

export function FeaturesSection({ features }: FeaturesSectionProps) {
  return (
    <Box
      sx={{
        py: { xs: 8, md: 10 },
        position: 'relative',
        color: 'common.white',
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          component="h2"
          sx={{
            textAlign: 'center',
            mb: { xs: 6, md: 8 },
            fontWeight: 800,
            color: 'common.white',
          }}
        >
          Why Choose BrainLoop?
        </Typography>
        <Grid container spacing={4}>
          {features.map((feature, index) => (
            <Grid item xs={12} md={4} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                style={{ height: '100%' }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    p: { xs: 3.5, md: 4 },
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    ...clayCard,
                  }}
                >
                  <Box sx={clayIconCircle}>
                    {feature.icon}
                  </Box>
                  <Typography
                    variant="h5"
                    component="h3"
                    sx={{ mb: 1.5, fontWeight: 700, color: 'white' }}
                  >
                    {feature.title}
                  </Typography>
                  <Typography sx={{ color: 'rgba(255,255,255,0.78)', lineHeight: 1.6 }}>
                    {feature.description}
                  </Typography>
                </Paper>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
